/**
 * @module contexts/AppStateProvider
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React, { createContext, useContext, useReducer } from 'react';

/**
 * Application state variables
 * ---------------------------
 */
type AppState = {
  url: string,
}


export const initialStateProduction: AppState = {
  url: document.getElementById('root')?.getAttribute('data-wf-config') ?? '/cache/wf/default.json' ,
};

type ActionSetStream = {
  type: 'SET_URL',
  payload: string,
}

type AppStateAction = ActionSetStream;

const reducer = (
  state: AppState,
  action: AppStateAction,
): AppState => {
  switch (action.type) {
    case 'SET_URL':
      return {
        ...state,
        url: action.payload,
      }
    default:
      return state;
  }
}

/**
 * React useContext hook
 * ---------------------
 */
type AppContextProps = [
  AppState,
  React.Dispatch<AppStateAction>,
]

export const AppContext = createContext<AppContextProps>([initialStateProduction, () => {}]);

type AppStateProviderProps = {
  initialState: AppState,
  children: React.ReactNode,
}

export const AppStateProvider = ({
  initialState,
  children
}: AppStateProviderProps) => (
  <AppContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </AppContext.Provider>
);

export const useAppState = () => useContext(AppContext);
